import { getLocalizedLanguageName } from "../../common/brows";

const userCustomLanguageKey = "userCustomLanguageKey";
const languageCodeKey = "languageCodeKey";

export function getLanguageCode(): string {
  const data = localStorage.getItem(userCustomLanguageKey);

  if (data !== null) {
    return data;
  }

  const languageCode = navigator.language;
  return languageCode.split("-")[0];
}

export function getLanguageString(): string {
  const languageCode = getLanguageCode();
  const localizedString = getLocalizedLanguageName(languageCode);
  return localizedString;
}

export function getUserCustomLanguage(): string | null {
  const data = localStorage.getItem(userCustomLanguageKey);
  return data;
}

export function setUserCustomLanguage(languageCode: string) {
  localStorage.setItem(userCustomLanguageKey, languageCode);
}
